import { useEffect, useState } from 'react';
import { getFileUrl, revokeFileUrl } from '../lib/s3';

/**
 * Loads cover/profile images directly from S3.
 */
export function useS3ImageUrls(cardInfo) {
  const [profileImageUrl, setProfileImageUrl] = useState('');
  const [coverImageUrl, setCoverImageUrl] = useState('');
  const [logoUrl, setLogoUrl] = useState('');

  useEffect(() => {
    let cancelled = false;
    let previousProfileUrl = '';
    let previousCoverUrl = '';
    let previousLogoUrl = '';

    const load = async () => {
      if (!cardInfo) {
        setProfileImageUrl('');
        setCoverImageUrl('');
        setLogoUrl('');
        return;
      }

      const profileKey = cardInfo.profile_image_url || cardInfo.profile_image;
      const coverKey = cardInfo.cover_image_url;
      const logoKey = cardInfo.logo_key;

      const [profile, cover, logo] = await Promise.all([
        profileKey ? getFileUrl(profileKey) : Promise.resolve(''),
        coverKey ? getFileUrl(coverKey) : Promise.resolve(''),
        logoKey ? getFileUrl(logoKey) : Promise.resolve(''),
      ]);

      if (cancelled) {
        revokeFileUrl(profile);
        revokeFileUrl(cover);
        revokeFileUrl(logo);
        return;
      }

      revokeFileUrl(previousProfileUrl);
      revokeFileUrl(previousCoverUrl);
      revokeFileUrl(previousLogoUrl);

      previousProfileUrl = profile || '';
      previousCoverUrl = cover || '';
      previousLogoUrl = logo || '';

      setProfileImageUrl(profile || '');
      setCoverImageUrl(cover || '');
      setLogoUrl(logo || '');
    };

    load();

    return () => {
      cancelled = true;
      revokeFileUrl(previousProfileUrl);
      revokeFileUrl(previousCoverUrl);
      revokeFileUrl(previousLogoUrl);
    };
  }, [cardInfo?.profile_image_url, cardInfo?.profile_image, cardInfo?.cover_image_url, cardInfo?.logo_key]);

  return { profileImageUrl, coverImageUrl, logoUrl };
}
